import { component as defineComponent } from 'flightjs';
import detachDropdown from '@99designs/asimov-detached-dropdown';

export default defineComponent(function () {
    this.attributes({
        'filterNameAttr': 'data-detached-dropdown-filter',
        'detachedDropdown': '[data-detached-dropdown]',
        'filterOptionItem': '[data-detached-dropdown-item]',
        'buttonLabel': '[data-button-label]',
        'buttonCount': '[data-button-count]'
    });

    this.after('initialize', function () {
        detachDropdown.createAll(this.select('detachedDropdown'));

        this.on(document, 'uiBrowseFiltersUpdated', this.updateDisplay);
        this.on('click', {
            'filterOptionItem': this.triggerBrowseFiltersUpdated
        });
    });

    this.triggerBrowseFiltersUpdated = function (e) {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var item = $(e.currentTarget);
        var value = item.attr('data-value');
        var payload = {};

        e.preventDefault();

        if ($(e.currentTarget).attr('data-disabled')) {
            return;
        }

        if (this.$node.data('filterValue') !== value) {
            this.$node.data('filterValue', value);
            payload[fieldName] = value;
            this.trigger('uiBrowseFiltersUpdated', payload);
        }
    };

    this.updateDisplay = function (e, data) {
        var field = this.$node.attr(this.attr.filterNameAttr);
        var title;
        var value;
        var count;

        if (data.hasOwnProperty(field)) {
            title = '';
            value = data[field];
            this.$node.data('filterValue', value);
            this.select('filterOptionItem').each(function () {
                if ($(this).attr('data-value') === value) {
                    $(this).attr('data-selected', 1);
                    title = $(this).attr('data-title');
                    count = $(this).attr('data-count');
                } else {
                    $(this).removeAttr('data-selected');
                }
            });

            if (title) {
                this.select('buttonLabel').text(title);
            }

            if (count) {
                this.select('buttonCount').text(count);
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/detached-dropdown-filter.js